import React from "react";

const Membership = () => <div>Membership</div>;

export default Membership;
